export default __webpack_public_path__ + "media/zurb/img/growth-design/marketing-sites-461288f2a51617a1bf7839f269e87421.png";